import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { Button, Card, CardColors, Alert } from '@/ui'

interface MessageBannerProps {
  close: () => void
  error: boolean
  message: string
  undo: () => void
}

export const MessageBanner = ({
  close,
  error,
  message,
  undo,
}: MessageBannerProps) => {
  return (
    <Card
      className="w-full"
      color={error ? CardColors.DANGER : CardColors.LEVEL_0}
    >
      {error && (
        <Alert variant="error" description={message} onClose={close}>
          <Button variant="link" onClick={undo}>
            Undo
          </Button>
        </Alert>
      )}
      {!error && (
        <Button
          variant="discreet"
          size="lg"
          iconLeft={solid('close')}
          onClick={close}
          aria-label="close button"
        />
      )}
    </Card>
  )
}
